<script>
import GalleryComponent from '../__components/Gallery.vue';
import MixinItem from '../__mixins/item';

export default {
  mixins: [MixinItem],
  components: {
    GalleryComponent,
  },
  props: {
    value: {
      type: Array,
    },
  },
  mounted() {
    this.$emit('fixed-label', true);
    this.$emit('show-border', false);
  },
};
</script>
<template>
  <GalleryComponent
    :value="value"
    :disabled="disabled"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  />
</template>
